<template>

  <template v-if="rows > 0">
    <tr v-for="r in rows" :key="r" class="celda">
      <td>
        &nbsp;
      </td>
    </tr>
  </template>

</template>

<script>

export default {
  name: 'Celda-Row-Vacio-Component',
  props: {
    rows: Number,
    forzar: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
    }
  },
  created() {
  },
  async mounted() {

  },
  methods: {},
  filters: {}
};
</script>

<style scoped>
  .celda {
    height: 26px;
  }
</style>
<script setup lang="ts">
</script>